var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProperties(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.705 8.1848L5.235 3.3008M1.254 5.8888L9.47 10.6418L17.684 5.8888M9.47 20.1188V10.6318M17.94 14.3968V6.8678C17.9398 6.53785 17.8528 6.21376 17.6878 5.92802C17.5228 5.64229 17.2856 5.40495 17 5.2398L10.411 1.4748C10.1249 1.30962 9.80036 1.22266 9.47 1.22266C9.13964 1.22266 8.8151 1.30962 8.529 1.4748L1.941 5.2398C1.65517 5.40482 1.41777 5.64211 1.2526 5.92785C1.08744 6.2136 1.00033 6.53775 1 6.8678V14.3968C1.00103 14.7262 1.08847 15.0495 1.2536 15.3345C1.41873 15.6195 1.65576 15.8561 1.941 16.0208L8.529 19.7858C8.8151 19.951 9.13964 20.0379 9.47 20.0379C9.80036 20.0379 10.1249 19.951 10.411 19.7858L17 16.0208C17.2851 15.856 17.5219 15.6193 17.6868 15.3343C17.8518 15.0493 17.9391 14.7261 17.94 14.3968Z",
    stroke: "#9D9FAB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperties);
export default __webpack_public_path__ + "static/media/Properties.861f63eba43c6b79d3c9048a4820beca.svg";
export { ForwardRef as ReactComponent };